import styled from "styled-components";
import React, { useEffect, useState } from "react";
import { Modal, Tabs } from "antd";
import SmallButton from "modules/Content/Shared/SmallButton";
import SentEmailSearch from "../../Campaigns/Emails/Components/SentEmailSearch";
import ModalGroupItem from "./ModalGroupItem";
import ModalIndivisualItem from "./ModalIndivisualItem";
import {
  createGroupForExportWidgets,
  getSalesXGroupDetails,
  getSalesXGroupsAction,
  getSalesXGroupUsersAction,
  removeExportedUsersGroupsFromRedux,
  resetSelectedGroup,
  resetSelectedGroupUsers,
  resetWidgetsListing,
  resetWidgetsPopupData,
  submitExportWidgetsStatus,
} from "../actions";
import { useSelector } from "react-redux";
import { RootState } from "store";
import InfiniteLoader from "modules/Common/Components/InfiniteLoader";
import { useHistory } from "react-router-dom";
import { getQueryCampaignId, getQueryEmailId, getQueryExportPopup } from "modules/EmailBrowser/utils";
import ModalGroupItemLoader from "../Loaders/ModalGroupItemLoader";
import ModalIndividualItemLoader from "../Loaders/ModalIndividualItemLoader";
import EmptyTabInfo from "modules/Content/Shared/EmptyTabInfo";
import Checkbox from "modules/Common/Components/Checkbox";
import ExportedMenu from "./ExportedMenu";
import ConfirmDialogWithModal from "modules/Common/Components/ConfirmDialogWithModal";
import { getQueryGroupId, getQueryNewGroup } from "../utils";

interface IExportWidgetPopUp {
  title: string;
  onClose: any;
  subtitle?: string;
}

const ExportWidgetPopUp: React.FC<IExportWidgetPopUp> = (props) => {
  const { title, subtitle, onClose } = props;
  const history = useHistory();

  // query data
  const queryEmailId = getQueryEmailId();
  const queryCampaignId = getQueryCampaignId();
  const queryGroupId = getQueryGroupId();
  const queryNewGroup = getQueryNewGroup();

  const queryParams = new URLSearchParams(window.location.search)

  const redirectGroupURL = `/groups/group-list?campaign_id=${queryCampaignId}&email_id=${queryEmailId}&exportPopup=true`


  // Redux States
  const groups = useSelector((state: RootState) => state.salesXGroups.groups.data);
  const groupsTotalCount = useSelector((state: RootState) => state.salesXGroups.groups.totalCount);
  const groupsLoading = useSelector((state: RootState) => state.salesXGroups.groups.loading);
  const users = useSelector((state: RootState) => state.salesXGroups.usersData.users);
  const usersTotalCount = useSelector((state: RootState) => state.salesXGroups.usersData.totalCount);
  const usersLoading = useSelector((state: RootState) => state.salesXGroups.usersData.loading);

  const selectedGroup = useSelector((state: RootState) => state.salesXGroups.selectedGroup);
  const selectedGroupLoading = useSelector((state: RootState) => state.salesXGroups.selectedGroup.loading);
  const selectedGroupUsers = useSelector((state: RootState) => state.salesXGroups.selectedGroup.users);
  const [searchTerm, setSearchTerm] = useState("");
  const [showGroupDetails, setShowGroupDetails] = useState(false);
  const [showExportSuccessPopup, setShowExportSuccessPopup] = useState(false);

  const [checkedUsers, setCheckedUsers]: any[] = useState([]);
  const [selectAllUsersExcept, setSelectAllUsersExcept]: any = useState([]);
  const [selectAllUsers, setSelectAllUsers] = useState(false);

  const [checkedGroups, setCheckedGroups]: any[] = useState([]);
  const [selectAllGroupsExcept, setSelectAllGroupsExcept]: any = useState([]);
  const [selectAllGroups, setSelectAllGroups] = useState(false);
  const [isExported, setIsExported] = useState(false);
  const [firstRender, setFirstRender] = useState(true);
  const [activeTab, setActiveTab] = useState('1');

  const turnoffGroupDetails = () => {
    setSearchTerm("");
    resetSelectedGroup();
    setShowGroupDetails(false);
    let replaceURL = false;
    if (queryParams.has('group_id')) {
      queryParams.delete('group_id')
      replaceURL = true;
    }
    if (queryParams.has('newGroup')) {
      queryParams.delete('newGroup')
      replaceURL = true;
    }
    if (replaceURL) history.replace({ search: queryParams.toString() })
  };

  // Group Export Status
  const setGroupStatus = (gid: any, status: any) => {
    if (selectAllGroups) {
      setSelectAllGroups(false);
      setSelectAllGroupsExcept([...selectAllGroupsExcept, gid]);
    } else {
      if (selectAllGroupsExcept.length > 0) {
        if (selectAllGroupsExcept.includes(gid)) {
          let filteredArr = selectAllGroupsExcept.filter((id: any) => id !== gid);
          setSelectAllGroupsExcept(filteredArr);
          if (filteredArr.length === 0) {
            setSelectAllGroups(true);
          }
        } else {
          setSelectAllGroupsExcept([...selectAllGroupsExcept, gid]);
        }
      } else {
        if (checkedGroups.includes(gid)) {
          setCheckedGroups(checkedGroups.filter((id: any) => id !== gid));
        } else {
          setCheckedGroups([...checkedGroups, gid]);
          if (checkedGroups.length + 1 === groupsTotalCount) setAllGroupsStatus();
        }
      }
    }
  };

  // User Export Status
  const setUserStatus = (uid: any, status: any) => {
    if (selectAllUsers) {
      setSelectAllUsers(false);
      setSelectAllUsersExcept([...selectAllUsersExcept, uid]);
    } else {
      if (selectAllUsersExcept.length > 0) {
        if (selectAllUsersExcept.includes(uid)) {
          let filteredArr = selectAllUsersExcept.filter((id: any) => id !== uid);
          setSelectAllUsersExcept(filteredArr);
          if (filteredArr.length === 0) {
            setSelectAllUsers(true);
          }
        } else {
          setSelectAllUsersExcept([...selectAllUsersExcept, uid]);
        }
      } else {
        if (checkedUsers.includes(uid)) {
          setCheckedUsers(checkedUsers.filter((id: any) => id !== uid));
        } else {
          setCheckedUsers([...checkedUsers, uid]);
          if (checkedUsers.length + 1 === usersTotalCount) setAllUsersStatus();
        }
      }
    }
  };

  const setAllUsersStatus = () => {
    if (selectAllUsers) {
      setSelectAllUsers(false);
    } else {
      setSelectAllUsers(true);
    }
    setCheckedUsers([]);
    setSelectAllUsersExcept([]);
  };

  const setAllGroupsStatus = () => {
    if (selectAllGroups) {
      setSelectAllGroups(false);
    } else {
      setSelectAllGroups(true);
    }
    setCheckedGroups([]);
    setSelectAllGroupsExcept([]);
  };
  const getPagination = (data: any, reset: any = false) => {
    let object: any = {};
    object.isExported = isExported;
    object.campaign_id = getQueryCampaignId();
    object.limit = 20;
    object.offset = reset ? 0 : data.length;
    if (searchTerm !== "") {
      object.searchTerm = searchTerm;
    }
    return object;
  };

  const searchHandler = (text: any) => {
    resetSelectionState();
    if (showGroupDetails) {
      setSearchTerm(text);
      resetSelectedGroupUsers();
      getSalesXGroupDetails({
        limit: 20,
        offset: 0,
        groupId: selectedGroup.groupId,
        ...(text ? { searchTerm: text } : {})
      });
    } else {
      setSearchTerm(text);
      resetWidgetsListing();
      getSalesXGroupsAction({ ...getPagination(groups, true), ...(text ? { searchTerm: text } : {}) });
      getSalesXGroupUsersAction({ ...getPagination(users, true), ...(text ? { searchTerm: text } : {}) });
    }
  };

  const resetSearch = () => {
    resetSelectionState();
    if (showGroupDetails) {
      setSearchTerm("");
      resetSelectedGroupUsers();
      getSalesXGroupDetails({
        limit: 20,
        offset: 0,
        groupId: selectedGroup.groupId,
      });
    } else {
      setSearchTerm("");
      resetWidgetsListing();
      let object: any = {};
      object.campaign_id = getQueryCampaignId();
      object.limit = 20;
      object.offset = 0;
      object.isExported = isExported;
      getSalesXGroupsAction(object);
      getSalesXGroupUsersAction(object);
    }
  };

  useEffect(() => {
    if (getQueryExportPopup() === "true") {
      setActiveTab('2');
      if (queryGroupId && queryNewGroup !== 'true') {
        onClickGroupHandler(queryGroupId);
      }
      if (queryNewGroup === 'true') {
        queryParams.delete('newGroup')
        if (queryGroupId) queryParams.delete('group_id');
        history.replace({ search: queryParams.toString() })
      }
    }
    return () => {
      resetWidgetsPopupData();
    };
  }, []);

  useEffect(() => {
    if (firstRender) {
      setFirstRender(false);
    } else {
      resetWidgetsListing();
      getSalesXGroupsAction(getPagination([], true));
      getSalesXGroupUsersAction(getPagination([], true));
    }
  }, [isExported]);

  const handleConfirmExportSalesXPopup = () => {
    setShowExportSuccessPopup(false);
    resetSelectionState();
    // onClose();
  };

  const resetSelectionState = () => {
    setSelectAllGroups(false);
    setSelectAllUsers(false);
    setCheckedGroups([]);
    setCheckedUsers([]);
    setSelectAllGroupsExcept([]);
    setSelectAllUsersExcept([]);
  };

  const setOnChange = (obj: any) => {
    console.log('obj: ', obj)
    setIsExported(obj["isExported"]);
    resetSelectionState();
    if (document.getElementById("tab-panel")) {
      document.getElementById("tab-panel").scrollTo(0, 0);
    }
  };

  const onClickGroupHandler = (gId: any) => {
    setSearchTerm("");
    if (queryParams.has('group_id')) {
      queryParams.delete('group_id');
    }
    queryParams.append('group_id', gId);
    history.replace({ search: queryParams.toString() })
    resetSelectedGroup();
    resetSelectionState();
    setShowGroupDetails(true);
    getSalesXGroupDetails({
      limit: 20,
      offset: 0,
      groupId: gId,
    })
  }

  const handleOnClose = () => {
    if (queryParams.has('exportPopup')) {
      queryParams.delete('exportPopup');
      history.replace({ search: queryParams.toString() })
    }
    if (onClose) {
      onClose();
    }
  }

  return (
    <>
      <StyledModal visible={true} footer={null} closable={false} width={"380px"} centered>
        <Wrapper>
          {/* Header of PopUp */}
          <div className="headerPopUp">
            {/* Title */}
            <div className="title_styles">
              {isExported ? "Currently Exported to:" : title}
              <sup>{isExported ? "" : subtitle}</sup>
            </div>
          </div>
          {/* Sub-Title */}
          {/* Search Bar */}
          <div className="d-flex">
            <div className="flex-grow-1 search-group search-div">
              <SentEmailSearch
                handleSearch={searchHandler}
                reset={resetSearch}
                placeholder="Search by Email/Name or Group"
              />
            </div>

            <label
              id="manage-group-list-qa"
              onClick={() => {
                createGroupForExportWidgets("", history);
              }}
              className="manage-group-btn"
            >
              Create Group
            </label>
          </div>
          {/* Body */}
          <div className="body-box-border">
            <div className="body-box">
              {!showGroupDetails && (
                <Tabs
                  defaultActiveKey={`${activeTab}`}
                  activeKey={activeTab}
                  onChange={(key) => setActiveTab(key)}
                  type="card"
                  tabBarGutter={0}
                  id={"exportTabs"}
                >
                  {/* Tab 1 */}
                  <Tabs.TabPane tab={`Individual (${usersTotalCount})`} key="1">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="checkbox-styles">
                        <Checkbox
                          width={"18px"}
                          height={"18px"}
                          disabled={usersTotalCount === 0 ? true : false}
                          onChange={setAllUsersStatus}
                          checked={selectAllUsers}
                        />
                        <span className="selectAll-text">Select All</span>
                      </div>
                      {selectAllUsers || checkedUsers.length > 0 || selectAllUsersExcept.length > 0 ?
                        <div className="selected-people-count">{`Selected People (${selectAllUsers
                          ? usersTotalCount
                          : selectAllUsersExcept.length > 0
                            ? usersTotalCount - selectAllUsersExcept.length
                            : checkedUsers.length
                          })`}</div>
                        : null}
                    </div>
                    <div className="tab" id="tab-panel">
                      <InfiniteLoader
                        dataLength={users.length + 1}
                        next={() => getSalesXGroupUsersAction(getPagination(users))}
                        hasMore={true}
                        // scrollableTarget={"exportTabIndividuals"}
                        loader={<ModalIndividualItemLoader loading={usersLoading} count={5} />}
                        scrollableTarget="tab-panel"
                      >
                        {users.map((user: any) => {
                          return (
                            <ModalIndivisualItem
                              person_name={user.firstName ? user.firstName + " " + user.lastName : user.email}
                              email={user.email}
                              designation={user.designation}
                              color={user.personalityColor}
                              imgUrl={user.profilePic}
                              checked={
                                selectAllUsers
                                  ? true
                                  : selectAllUsersExcept.includes(user.userId)
                                    ? false
                                    : checkedUsers.includes(user.userId) || selectAllUsersExcept.length > 0
                              }
                              onCheckChange={(e) => {
                                setUserStatus(user.userId, !user.exportStatus);
                              }}
                            />
                          );
                        })}
                      </InfiniteLoader>
                      {users.length === 0 && usersLoading === false ? (
                        <EmptyTabInfo
                          className="no-data-text"
                          description={`No individuals found ${searchTerm !== "" ? "against your search" : ""}`}
                        ></EmptyTabInfo>
                      ) : null}
                    </div>
                  </Tabs.TabPane>
                  {/* Tab 2 */}
                  <Tabs.TabPane tab={`Groups (${groupsTotalCount})`} key="2">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="checkbox-styles">
                        <Checkbox
                          width={"18px"}
                          height={"18px"}
                          disabled={groupsTotalCount === 0 ? true : false}
                          onChange={setAllGroupsStatus}
                          checked={selectAllGroups}
                        />
                        <span className="selectAll-text">Select All</span>
                      </div>
                      {selectAllGroups || checkedGroups.length > 0 || selectAllGroupsExcept.length > 0 ?
                        <div className="selected-group-count">{`Selected Group (${selectAllGroups
                          ? groupsTotalCount
                          : selectAllGroupsExcept.length > 0
                            ? groupsTotalCount - selectAllGroupsExcept.length
                            : checkedGroups.length
                          })`}
                        </div> : null}
                    </div>
                    <div className="tab" id="tab-panel-1">
                      <InfiniteLoader
                        dataLength={groups.length + 1}
                        next={() => getSalesXGroupsAction(getPagination(groups))}
                        hasMore={true}
                        // scrollableTarget={"exportTabIndividuals"}
                        loader={<ModalGroupItemLoader loading={groupsLoading} count={5} />}
                        scrollableTarget="tab-panel-1"
                      >
                        {groups.map((group: any) => {
                          return (
                            <ModalGroupItem
                              name={group.groupName}
                              userCount={group.totalUsers}
                              checked={
                                selectAllGroups
                                  ? true
                                  : selectAllGroupsExcept.includes(group.groupId)
                                    ? false
                                    : checkedGroups.includes(group.groupId) || selectAllGroupsExcept.length > 0
                              }
                              onCheckChange={(e) => {
                                setGroupStatus(group.groupId, !group.exportStatus);
                              }}
                              onClick={() => onClickGroupHandler(group?.groupId)}
                            />
                          );
                        })}
                      </InfiniteLoader>
                      {groups.length === 0 && groupsLoading === false ? (
                        <EmptyTabInfo
                          className="no-data-text"
                          description={`No groups found ${searchTerm !== "" ? "against your search" : ""}`}
                        ></EmptyTabInfo>
                      ) : null}
                    </div>
                  </Tabs.TabPane>
                </Tabs>
              )}
              {showGroupDetails && (
                <>
                  <div className="members-style">{`Members (${selectedGroup.totalCount})`}</div>
                  <div className="tab groupDetails" id="tab-panel">
                    <InfiniteLoader
                      dataLength={selectedGroup.users.length + 1}
                      next={() =>
                        getSalesXGroupDetails({
                          limit: 20,
                          offset: selectedGroup.users.length,
                          groupId: selectedGroup.groupId,
                          ...(searchTerm ? { searchTerm } : {}),
                        })
                      }
                      hasMore={true}
                      // scrollableTarget={"exportTabIndividuals"}
                      loader={<ModalIndividualItemLoader loading={selectedGroupLoading} count={5} />}
                      scrollableTarget="tab-panel"
                    >
                      {selectedGroup.users.map((user: any) => {
                        return (
                          <ModalIndivisualItem
                            person_name={user.firstName ? user.firstName + " " + user.lastName : user.email}
                            email={user.email}
                            designation={user.designation}
                            color={user.personalityColor}
                            showCheckbox={false}
                            imgUrl={user.profilePic}
                          />
                        );
                      })}
                    </InfiniteLoader>
                    {selectedGroup.users.length === 0 && selectedGroupLoading === false ? (
                      <EmptyTabInfo className="no-data-text" description={`No individuals found`}></EmptyTabInfo>
                    ) : null}
                  </div>
                </>
              )}
              {/* Sort Icon */}
              {!showGroupDetails && <ExportedMenu value={isExported ? 2 : 1} setOnChange={setOnChange} />}
            </div>
          </div>
          {/* Buttons */}
          <div className="buttons">
            <SmallButton
              title={showGroupDetails ? "Edit" : isExported ? "Undo" : "Export"}
              outline={`${showGroupDetails
                ? selectedGroupLoading ? "disabled"
                  : selectedGroup?.isDeletable
                    ? ""
                    : "disabled"
                : selectAllGroups || selectAllUsers
                  ? ""
                  : users.length + groups.length === 0
                    ? "disabled"
                    : checkedGroups.length +
                      selectAllGroupsExcept.length +
                      checkedUsers.length +
                      selectAllUsersExcept.length ===
                      0
                      ? "disabled"
                      : (selectAllGroupsExcept.length < groupsTotalCount && selectAllGroupsExcept.length !== 0) ||
                        (selectAllUsersExcept.length < usersTotalCount && selectAllUsersExcept.length !== 0)
                        ? ""
                        : (selectAllGroupsExcept.length === groupsTotalCount ||
                          selectAllUsersExcept.length === usersTotalCount) &&
                          checkedGroups.length + checkedUsers.length === 0
                          ? "disabled"
                          : ""
                }  btns success-btn `} //to handle disable
              onClick={() => {
                showGroupDetails
                  ? history.push(`${redirectGroupURL}&group_id=${selectedGroup.groupId}`)
                  : submitExportWidgetsStatus({
                    searchTerm,
                    campaignId: getQueryCampaignId(),
                    isExported,
                    checkedUsers,
                    selectAllUsersExcept,
                    selectAllUsers: selectAllUsers || selectAllUsersExcept.length > 0,
                    checkedGroups,
                    selectAllGroupsExcept,
                    selectAllGroups: selectAllGroups || selectAllGroupsExcept.length > 0,
                  }).then(() => {
                    resetSelectionState();
                    removeExportedUsersGroupsFromRedux({
                      checkedUsers,
                      selectAllUsersExcept,
                      selectAllUsers: selectAllUsers || selectAllUsersExcept.length > 0,
                      checkedGroups,
                      selectAllGroupsExcept,
                      selectAllGroups: selectAllGroups || selectAllGroupsExcept.length > 0,
                    });
                    setShowExportSuccessPopup(true);
                  });
              }}
            />
            <SmallButton
              title={showGroupDetails ? "Back" : "Cancel"}
              outline="btns outline "
              onClick={showGroupDetails ? turnoffGroupDetails : handleOnClose}
            />
          </div>
        </Wrapper>
        {showExportSuccessPopup && (
          <WrapperNotice className="football">
            <div className="back-overlay" />
            <ConfirmDialogWithModal
              confirm="Ok"
              onConfirm={handleConfirmExportSalesXPopup}
              onCancel={handleConfirmExportSalesXPopup}
              title={isExported ? "Widgets removed successfully" : "Widgets exported successfully"}
              titleQuestion={null}
            />
          </WrapperNotice>
        )}
      </StyledModal>
    </>
  );
};

export default ExportWidgetPopUp;
const WrapperNotice = styled.div`
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
  .back-overlay {
    position: fixed;
    background: #000;
    opacity: 0.6;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
  }
`;

const Wrapper = styled.div`
  .no-data-text {
    width: 100%;
  }
  .search-div {
    padding-right: 24px;
  }
  .manage-group-btn {
    font-weight: 700;
    font-size: 14px;
    color: #27ce0a;
    font-family: Helvetica;
    cursor: pointer;
    padding: 8px 0 6px 0;
  }
  .headerPopUp {
    display: flex;
    align-items: center;
  }
  .disabled {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.5;
  }
  .members-style {
    font-family: "Roboto Slab";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
    letter-spacing: -0.45px;
    color: #424b50;
  }
  .title_styles {
    font-family: "Roboto Slab";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 27px;
    letter-spacing: -1.16667px;
    color: #424b50;
    margin-bottom: 11px;
    sup {
      font-size: 10px;
      vertical-align: super;
    }
  }
  .vertical_line {
    font-size: 24px;
    height: 24px;
    border-left: 1px solid #dddddd;
    width: 1px;
    padding: 0;
    background: #dddddd;
    margin-left: 9px;
    margin-right: 8px;
    margin-bottom: 2px;
  }
  .subtitle_styles {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 34px;
    letter-spacing: -0.4px;
    color: #5e7079;
    margin-bottom: 9px;
    margin-left: 42px;
  }
  .tab {
    margin-left: auto;
    display: flex;
    flex-wrap: wrap;
    margin-top: 8px;
    overflow: auto;
    height: calc(100vh - 630px);
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: calc(100vh - 405px);
    }
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-bottom: 4px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
      border-radius: 3px;
    }
  }
  .ant-tabs-nav {
    margin: 0;
  }
  .checkbox-styles {
    margin-top: 3px;
    margin-left: 2px;
  }
  .checkbox-styles > div {
    margin-top: 1px;
  }
  .selected-group-count,
  .selected-people-count {
    font-size: 11px;
    font-family: "Roboto";
    font-weight: 700;
    color: #27ce0a;
  }
  .selectAll-text {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 10px;
    letter-spacing: -0.180814px;
    color: #5e7079;
    padding-top: 3px;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 24px;
  }
  .btns {
    padding: 8px 32px;
    font-family: Helvetica;
    font-size: 16px;
    font-weight: 700;
    border-width: 2px;
    border-radius: 32px;
    line-height: 20px;
    &.success-btn {
      margin-right: 8px;
    }
  }
  .body-box-border {
    box-sizing: border-box;
    background: #ffffff;
    margin-top: 12px;
    height: calc(100vh - 550px);
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: calc(100vh - 325px);
    }
  }
  .body-box {
    position: relative;
  }
  .groupDetails {
    height: calc(100vh - 580px);
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: calc(100vh - 355px);
    }
  }
`;

const StyledModal = styled(Modal)`
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    top: 26px;
  }
  .ant-modal-content {
    border-radius: 18px;
    box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.123188);
  }
  .ant-modal-body {
    padding: 28px 32px;
  }
  .ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab {
    background: #fff;
    border-color: #dadada !important;
  }
  .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active {
    border-bottom-color: #f0f0f0;
    background: #def6e6;
  }
  .ant-tabs-card.ant-tabs-top > .ant-tabs-nav {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: #7e7e7e;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #1ec252;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
  .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab:nth-child(1) {
    border-radius: 8px 0px 0px 8px;
  }
  .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab:nth-child(2) {
    border-radius: 0px 8px 8px 0px;
  }
`;
